import "../scss/page.scss";

import "../scss/login.scss";
import initPasswordToggles from "./scripts/common/password-toggle.js";

initPasswordToggles();
